import api from "../../api/api";




const receivePayment = (data) =>{
    return new Promise((resolve, reject)=>{
        api.post("/invoice/receive-payment",data).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg :res.data.msg,
                })
            }
          }).catch( (error) => {
            reject({
                msg : "Something Went Wrog",
                error : error
            })
          })
    })
}




const invoiceServices = {
    receivePayment
}
export default invoiceServices;